<template>
  <AddStudent update />
</template>
<script>
import appConfig from '@/app.config'
import AddStudent from '../../../components/dadban/students/AddStudent.vue'
export default {
  page: {
    title: 'ویرایش اطلاعات دانش پذیر',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-edit-students',
  components: {
    AddStudent,
  },
}
</script>
